export default class KilometerCourseEditStartingBaseTemplate {
  // eslint-disable-next-line class-methods-use-this
  payload(ride) {
    return { id: ride['@id'], type: 'kilometerCourseRide' };
  }
}
